<template>
  <footer>
    <span class="component-label">{{'&lt;' + $options.name + ' />'}}</span>
  </footer>
</template>
<script>
export default {
  name: 'PublicLayoutFooter'
}
</script>



// WEBPACK FOOTER //
// src/layouts/public-layout/PublicLayoutFooter.vue